// src/components/Shared/NavigationBar.jsx
// Updated for Eventory SaaS - no role-based navigation

import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

const NavigationBar = () => {
  const { isAuthenticated, user, logout } = useContext(AuthContext);
  const location = useLocation();

  // Hide the legacy navbar on routes that ship their own marketing chrome
  // (PlaceholderLanding TopNav, MarketingShell, etc.). Otherwise the page
  // renders TWO headers stacked — including a duplicated "logo + Eventory"
  // text combo on /demo that founders flagged as inconsistent.
  const SUPPRESS_LEGACY_NAV = ['/', '/demo', '/pricing', '/privacy', '/terms'];
  if (SUPPRESS_LEGACY_NAV.includes(location.pathname)) {
    return null;
  }

  return (
    <nav className="ev-main-nav">
      <div className="ev-main-nav-inner">
        <Link to={isAuthenticated ? '/dashboard' : '/'} className="ev-main-brand">
          <img src="/images/eventory-logo.svg" alt="Eventory" />
          <span>Eventory</span>
        </Link>
        
        <div className="ev-main-nav-links">
          {!isAuthenticated ? (
            <>
              <Link to="/login" className="ev-main-link">
                Sign In
              </Link>
              <Link to="/register" className="ev-primary-btn ev-main-btn">
                Get Started
              </Link>
            </>
          ) : (
            <>
              <Link to="/dashboard" className="ev-main-link">
                My Events
              </Link>
              <p className="ev-main-user">
                {user?.name}
              </p>
              <button 
                onClick={logout} 
                className="ev-soft-btn ev-main-btn"
              >
                Sign Out
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default NavigationBar;
